<template>
    <div class="get-started-item d-flex">
        <img v-if="item.img" :src="item.img" :alt="item.title">
        <div class="get-started-content">
            <h1 v-if="item.title">{{item.title}}</h1>
            <p v-if="item.content">{{item.content}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['item'],
    data() {
        return {

        }
    }
}
</script>